const IGNORABLE_CLIENT_RUNTIME_ERROR = [
  'Wasm SIMD unsupported',
  'v128 not enabled',
  'WebAssembly is not defined',
  "Can't find variable: WebAssembly",
  'Cannot allocate Wasm memory',
  'Aborted(InternalError: out of memory)',
  'Aborted(out of memory)',
  'Aborted(RangeError: Out of memory)',
  'Array buffer allocation failed',
  'uncaught exception: out of memory',
  'Promise.try is not a function',
];

// Third-party scripts served through first-party paths, which Sentry's `denyUrls` can't match without a stack.
const IGNORABLE_SCRIPT_SOURCE = [
  '/zrgevpf/', // Google Tag Manager gateway
];

const getScriptSource = (error: Error): string => {
  const source = (error as { sourceURL?: unknown }).sourceURL ?? (error as { fileName?: unknown }).fileName;
  return typeof source === 'string' ? source : '';
};

export const isIgnorableClientRuntimeError = (error: unknown): boolean => {
  if (error instanceof Error) {
    const source = getScriptSource(error);
    if (source && IGNORABLE_SCRIPT_SOURCE.some(part => source.includes(part))) return true;
  }
  const message = typeof error === 'string' ? error : error instanceof Error ? error.message : '';
  if (!message) return false;
  return IGNORABLE_CLIENT_RUNTIME_ERROR.some(part => message.includes(part));
};
